// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Collections from './Collections';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Collections);
